module.exports = __webpack_public_path__ + "static/media/Danone_Thin.5a42f70a.woff2";